export default __webpack_public_path__ + "static/media/employment_page.431d1953.pdf";